<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-row :span="24" style="margin-bottom: 25px; box-sizing: border-box" type="flex" justify="end">
        <a-col :span="15"></a-col>
        <a-col :span="9" style="text-align: right">
          <!--              查询功能待完善 只能查询公司名-->
          <a-button type="primary"
            ><a href="/订单导入模板.xlsx" download="订单导入模板.xlsx" style="text-decoration: none"
              >下载导入模板</a
            ></a-button
          >

          <a-upload
            v-if="orderimport"
            style="margin: 0 8px"
            name="file"
            :action="uploadUrl"
            @change="handleChange"
            :headers="headers"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :showUploadList="false"
          >
            <a-button type="primary"> 导入EXCEL </a-button>
          </a-upload>
          <!--<a-button  type="primary" style="margin-left: 8px;" @click="">导入EXCEL</a-button>-->
          <a-button type="primary" style="margin-left: 8px" v-if="orderexport" @click="exportEnted">导出EXCEL</a-button>
        </a-col>
      </a-row>
      <a-form layout="inline" :form="form" v-on:keyup.enter="$refs.table.refresh(true)">
        <!--        筛选的条件-->
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="订单号" style="margin-left: 14px">
              <a-input v-model="queryParam.orderNo" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item style="margin-left: 28px" label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.orderStatus" :allowClear="true">
                <a-select-option v-for="type in order_status" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="客户姓名">
              <a-input v-model="queryParam.clientName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="客户联系方式">
              <a-input v-model="queryParam.clientPhone" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-row :gutter="24" style="margin-left: 0px; margin-right: 0px">
              <a-form-item label="客户地址">
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                    <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">{{
                      type.provinceName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                    <a-select-option v-for="type in selectCityName" :key="type.cityCode">{{
                      type.cityName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.area" :allowClear="true">
                    <a-select-option v-for="type in selectAreaName" :key="type.areaCode">{{
                      type.areaName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="9" :sm="24">
                  <a-input v-model="queryParam.clientAddress" />
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="品牌" style="margin-left: 28px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeBrandName"
                :filterOption="filterOption"
                v-model="queryParam.brandId"
              >
                <a-select-option v-for="type in selectBrand" :key="type.brandId">{{ type.brandName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="型号" style="margin-left: 56px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeModelName"
                :filterOption="filterOption"
                v-model="queryParam.modelId"
              >
                <a-select-option v-for="type in selectModel" :key="type.modelId">{{ type.modelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="购买渠道">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changesourceName"
                :filterOption="filterOption"
                v-model="queryParam.buyWay"
              >
                <a-select-option v-for="type in selectChannel" :key="type.channelId"
                  >{{ type.channelName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="信息来源">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeinfoSourceName"
                :filterOption="filterOption"
                v-model="queryParam.infoSourceId"
              >
                <a-select-option v-for="type in selectSource" :key="type.sourceId"
                  >{{ type.sourceName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="师傅姓名">
              <a-input v-model="queryParam.masterName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="师傅联系方式">
              <a-input v-model="queryParam.masterPhone" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="序列号" style="margin-left: 14px">
              <a-input v-model="queryParam.serialNumber" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="原始单号">
              <a-input v-model="queryParam.originalOrderNo" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="isShow == 1">
          <a-col :md="12" :sm="24">
            <a-form-item>
              <a-col :md="12" :sm="24">
                <a-select v-model="queryParam.timeType">
                  <a-select-option v-for="type in time_type" :key="type.code">{{ type.label }}</a-select-option>
                </a-select>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-range-picker
                  format="YYYY-MM-DD HH:mm:ss"
                  style="width: 100%"
                  v-model="dtoListtab.timedata"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChangerangepicker"
                />
              </a-col>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="建单人" style="margin-left: 14px">
              <a-input v-model="queryParam.createBy" />
            </a-form-item>
          </a-col>
          <!--<a-col :md="6" :sm="24">-->
          <!--<a-form-item  >-->
          <!--<a-col :md="6" :sm="24">-->
          <!--<a-select  v-model="dtoListtab3.timeType">-->
          <!--<a-select-option  v-for="type in time_type" :key="type.code"-->
          <!--&gt;{{type-->
          <!--.label}}</a-select-option>-->
          <!--</a-select>-->
          <!--</a-col>-->
          <!--<a-col :md="18" :sm="24">-->
          <!--<a-range-picker-->
          <!--v-model="dtoListtab3.timedata"-->
          <!--format="YYYY-MM-DD HH:mm"-->
          <!--@change="onChangerangepicker3"-->
          <!--/>-->
          <!--</a-col>-->
          <!--</a-form-item>-->
          <!--</a-col>-->
          <!--<a-col :md="6" :sm="24">-->
          <!--<a-form-item  >-->
          <!--<a-col :md="6" :sm="24">-->
          <!--<a-select v-model="dtoListtab2.timeType">-->
          <!--<a-select-option  v-for="type in time_type" :key="type.code">{{type.label}}</a-select-option>-->
          <!--</a-select>-->
          <!--</a-col>-->
          <!--<a-col :md="18" :sm="24">-->
          <!--<a-range-picker-->
          <!--v-model="dtoListtab2.timedata"-->
          <!--format="YYYY-MM-DD HH:mm"-->
          <!--@change="onChangerangepicker2"-->
          <!--/>-->
          <!--</a-col>-->
          <!--</a-form-item>-->
          <!--</a-col>-->
        </a-row>
        <a-row :gutter="24" v-if="isShow == 1">
          <a-col :md="6" :sm="24">
            <a-form-item label="快递公司">
              <a-select v-model="queryParam.courierServicesCompany">
                <a-select-option v-for="type in delivery_company" :key="type.label.dictValue">{{
                  type.label.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="快递单号" style="margin-left: 28px">
              <a-input v-model="queryParam.courierNumber" />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item label="备注" style="margin-left: 28px">
              <a-input v-model="queryParam.content" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="isShow == 1">
          <a-col :md="6" :sm="24">
            <a-form-item label="结算角色">
              <a-select v-model="queryParam.settleUser">
                <a-select-option v-for="type in settle_role" :key="type.label.dictValue">{{
                  type.label.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="结算状态" style="margin-left: 28px">
              <a-select v-model="queryParam.settleStatus">
                <a-select-option v-for="type in settlement_status" :key="type.label.dictValue">{{
                  type.label.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        查询和清空按钮-->
        <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="8" style="display: flex; justify-content: space-between">
              <a-checkbox v-model="checkboxlist.notFinishOrder" @change="onChangeUndoneOrder">未完成订单</a-checkbox>
              <a-checkbox v-model="checkboxlist.urgentOrder" @change="onChangeUrgentOrder">加急订单</a-checkbox>
              <a-checkbox v-model="checkboxlist.weightOrder" @change="onChangeMainOrder">重要订单</a-checkbox>
            </a-col>
          </a-row>
        </span>
        <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="4" :offset="10">
              <span v-if="isShow == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <!--<a-divider type="vertical" />-->
              <span v-if="isShow == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="5" :offset="5" style="text-align: right">
              <!--              查询功能待完善 只能查询公司名-->
              <a-button type="primary" @click="query()">查询</a-button>
              <a-button style="margin-left: 18px" @click="empty()">清空</a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-divider></a-divider>
            <a-col :span="4" :offset="20">
              <!--              查询功能待完善 只能查询公司名-->
              <!--              <router-link :to="{ name: 'NewlyaddedOrderList' }">-->
              <a-button class="ncreate" type="primary" @click="goNewlyaddedOrderList" v-if="orderadd"
                >新增订单
              </a-button>
              <a-button
                class="ncreate"
                type="primary"
                style="margin: 0 20px"
                v-if="batchDispatch"
                @click="dispatchBatch"
                >批量派单
              </a-button>
            </a-col>
          </a-row>
        </span>
      </a-form>
    </div>
    <!--    表格内容-->
    <s-table
      size="default"
      ref="table"
      rowKey="orderId"
      :columns="columns"
      :data="loadData"
      bordered
      :scroll="{ x: 300 }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :rowClassName="setClassName"
    >
      <span slot="action" slot-scope="text, record">
        <a v-if="orderdetail" @click="editorder(record)">编辑</a>
        <a-divider type="vertical" v-if="orderdetail" />
        <!--<a  v-if="record.orderStatus=='待派单'&&orderdispatch" @click="distribute(record)">派单</a>-->
        <!--<a-divider type="vertical" v-if="record.orderStatus=='待派单'&&orderdispatch"/>-->
        <!--<a  v-if="record.orderStatus!='待派单'&&record.orderStatus!='已结单'&&reassignment"-->
        <!--@click="reassignmentorder(record)">重新派单</a>-->
        <!--<a-divider type="vertical" v-if="record.orderStatus!='待派单'&&record.orderStatus!='已结单'&&reassignment"/>-->
        <!--<a v-if="changeDispatch" @click="orderReformist(record)">改派</a>-->
        <!--<a-divider type="vertical"v-if="changeDispatch" />-->

        <a v-if="changeDispatch" @click="addremark(record)">备注</a>
        <a-divider type="vertical" v-if="changeDispatch" />
        <a v-if="orderremove" @click="delByIds(record)">移除</a>
      </span>
      <span slot="clientAddress" slot-scope="text, record">
        <a @click="changeclientAddress(record)">{{ record.clientAddress }}</a>
      </span>
      <span slot="orderNo" slot-scope="text, record">
        <a @click="addremark(record)">{{ record.orderNo }}</a>
      </span>
    </s-table>
    <!-- 使用弹框组件-->
    <Enterprise-modal ref="modal" @ok="handleOk" />
    <!--    移除对账单确定按钮-->
    <a-modal
      title="移除"
      style="top: 20px"
      :width="800"
      v-model="removeible"
      :confirmLoading="confirmLoading"
      @ok="confirmOk"
      @cancel="confirmCancel"
    >
      <a-form ref="ruleForm" :form="form">
        <a-form-item label="移除类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="[
              'removeType',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择移除类型!'
                  }
                ]
              }
            ]"
            @change="removeTypechange"
          >
            <a-select-option v-for="type in remove_type" :key="type.label.dictValue">{{
              type.label.dictLabel
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="textarea"
            v-decorator="[
              'removeText',
              {
                rules: [
                  {
                    required: this.removerequiredbool,
                    message: '请填写备注!'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="改派"
      style="top: 20px"
      :width="800"
      v-model="reformistible"
      @ok="reformistOk"
      @cancel="reformistCancel"
    >
      <a-form :form="formreformist">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['orderId']" />
            </a-form-item>
            <a-form-item label="当前主负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['oldorderPrincipal']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新主负责人">
              <a-select v-decorator="['orderPrincipal']">
                <a-select-option v-for="type in findByDeptId" :key="type.userId">{{ type.userName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="changeclientAddressible" @ok="determinechangeclientAddress()" title="修改客户地址">
      <a-form :form="formchangeclientAddress">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['orderId']" />
            </a-form-item>
            <a-form-item label="省" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                @change="getselect"
                v-decorator="['provinceId', { rules: [{ required: true, message: '请选择客户地址!' }] }]"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">
                  {{ type.provinceName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市">
              <a-select
                v-decorator="['cityId', { rules: [{ required: true, message: '请选择客户地址!' }] }]"
                @change="getprovinceName"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectCityName" :key="type.cityCode">
                  {{ type.cityName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区">
              <a-select
                v-decorator="['areaId', { rules: [{ required: true, message: '请选择客户地址!' }] }]"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectAreaName" :key="type.areaCode">
                  {{ type.areaName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="详细地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['address', { rules: [{ required: true, message: '请填写详细地址!' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      title="导入失败文件"
      style="top: 20px"
      v-model="bisible"
      @ok="handleSubmit2"
      :closable="false"
      :maskClosable="false"
    >
      <div style="margin-left: 50px">
        <p>
          <strong>导入成功数量 : </strong>
          <span>{{ success }}</span>
        </p>
        <p>
          <strong>导入失败数量 : </strong>
          <sapn style="color: red">{{ err }}</sapn>
        </p>
        <strong v-if="err == 0">全部导入成功！</strong>
        <strong v-else>是否下载导入失败文件？</strong>
      </div>
    </a-modal>
    <newlyadded-order-list-model
      @ok="$refs.table.refresh(true)"
      ref="newlyaddedorderlist"
    ></newlyadded-order-list-model>
    <edit-order-model
      v-if="$store.state.user_type == 1"
      ref="editordermodel22"
      @ok="$refs.table.refresh()"
    ></edit-order-model>
    <edit-order-model1 v-else ref="editordermodel22" @ok="$refs.table.refresh()"></edit-order-model1>
    <change-remarks-model @ok="$refs.table.refresh()" ref="changeremarksmodel"></change-remarks-model>
  </a-card>
</template>
<script>
import changeRemarksModel from '../order/modules/changeRemarksModel'
import NewlyaddedOrderListModel from '../order/modules/NewlyaddedOrderListModel'
import { checkPermission } from '@/utils/permissions'
import { STable } from '@/components'
import { enterpriseOrderList, exportEnt } from '@/api/enterprise/EnterpriseOrderManagement'
import { selectFindAll } from '@/api/enterprise/enterprise'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'

import {
  downloadErrorMaster,
  getSourceList,
  getSelectBrand,
  getSelectModel,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getdeleteOrder,
  getList,
  getOrderDetail,
  getorderInfo,
  getfindByDeptId,
  getmarketPrincipal,
  getisOrderOpened,
  getagainDispatchOrder,
  getmasterPrincipal,
  getchangeOrderPrincipal,
  getexportList
} from '@/api/order/orderList'
import { getselectChannel, getselectSource, getselectCombox } from '@/api/order/NewlyaddedOrderList'
import { getupdateOrder } from '@/api/order/editorder'
import { getDictMap } from '../../utils/dict'
import pick from 'lodash.pick'
import ARow from 'ant-design-vue/es/grid/Row'
const options = [
  { label: '未完成订单', value: '为完成订单' },
  { label: '暂不结算', value: '暂不结算' },

  { label: '该账号订单', value: '该账号订单' },
  { label: '加急订单', value: '加急订单' },
  { label: '重要订单', value: '重要订单' },
  { label: '冻结订单', value: '冻结订单' }
]
const optionsradio = [
  { label: '小时', value: '0' },
  { label: '天', value: '1' }
]

export default {
  name: 'EnterpriseBill',
  components: {
    ARow,
    STable,
    NewlyaddedOrderListModel,
    editOrderModel: () => import('../order/modules/editOrderModel'),
    editOrderModel1: () => import('../order/modules/editOrderModel1'),
    changeRemarksModel
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/order/enterpriseOrder/batchOrderImport',
      form: this.$form.createForm(this),
      isShow: 0,
      EnterDisabled: false,
      success: 0,
      arrList: [],
      bisible: false,
      err: 0,
      checkboxlist: {},
      selectedRowKeys: [],
      order_substate: [],
      selectedRows: [],
      dtoListtab: {},
      dtoListtab2: {},
      dtoListtab3: {},
      // 查询信息来源下拉框
      selectSource: [],
      // 查询购买渠道下拉框
      selectChannel: [],
      selectCombox: [],
      List: [],
      valueRadio: '0',
      value: '0',
      valuecheckbox: [],
      options,
      optionsradio,
      orderId: '',
      removeText: '',
      removeType: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 字典为订单状态
      order_status: [],
      // 字典为订单超时状态
      timeout_type: [],
      // 字典为付款状态
      pay_status: [],
      // 字典为快递公司
      delivery_company: [],
      // 字典为快递公司
      tech_level: [],
      // 字典为快递公司
      worker_type: [],
      // 时间类型
      selectBrand: [],
      // 查询品牌下拉框
      time_type: [
        { code: 0, label: '建单时间' },
        { code: 1, label: '预约上门时间' },
        { code: 2, label: '销单时间' },
        { code: 3, label: '核销时间' },
        { code: 4, label: '订单完成时间' },
        { code: 5, label: '结算完成时间' }
      ],
      // 付款方式
      pay_type: [],
      // 结算角色
      settle_role: [],
      // 结算状态
      settlement_status: [],
      // 结算状态
      settle_cycle: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      // 查询型号下拉框
      selectModel: [],
      // 查询型号下拉框
      remove_type: [],
      remarkInfoState: false,
      removeible: false,
      removeLoading: false,
      reformistible: false,
      loading: false,
      changeclientAddressible: false,
      removerequiredbool: false,

      OrderOpenedForm: this.$form.createForm(this),
      formreformist: this.$form.createForm(this),
      formchangeclientAddress: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      dtoList: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          width: '20px',
          align: 'center'
        },
        {
          title: '操作栏',
          width: '20px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubstate',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center'
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',

          scopedSlots: { customRender: 'clientAddress' },
          width: '300px'
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center'
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterPhone',
          align: 'center'
        },
        {
          title: '付款方式',
          dataIndex: 'payType',
          align: 'center'
        },
        {
          title: '预约上门时间',
          dataIndex: 'reserveTimePart',
          align: 'center'
        },
        {
          title: '销单时间',
          dataIndex: 'saleTime',
          align: 'center'
        },
        {
          title: '核销时间',
          dataIndex: 'checkTime',
          align: 'center'
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center'
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '暂不结算时间',
          dataIndex: 'temporarilySettleTime',
          align: 'center'
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      // post的返回值
      reslist: '',
      findByDeptId: [],
      isOrderOpenedmsg: [],
      marketPrincipal: [],
      loadData: parameter => {
        console.log(this.$store.getters.enterpriseId, 'this.$store.getters.enterpriseId')
        let StoreUserId = this.$store.getters.enterpriseId
        if (StoreUserId.length != 0) {
          this.queryParam.enterpriseId = StoreUserId
          this.EnterDisabled = true
        }
        return enterpriseOrderList(Object.assign(parameter, this.queryParam))
      },
      data: [],

      // 字典为是否
      restaurantTypes: [],
      // 字典为安装类型
      installTypes: [],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      orderadd: checkPermission('order:list:add'),
      orderimport: checkPermission('order:list:import'),
      orderexport: checkPermission('order:list:export'),
      orderdetail: checkPermission('order:list:detail'),
      orderdispatch: checkPermission('order:manualr:derdispatch'),
      batchDispatch: checkPermission('order:list:dispatch:batch'),
      orderremove: checkPermission('order:list:remove'),
      changeDispatch: checkPermission('order:list:changeDispatch'),
      reassignment: checkPermission('order:list:reassignment'),
      editordererecord: '',
      masterPrincipal: []
    }
  },
  filters: {},
  mounted() {
    // this.queryParam.orderNo=this.$route.query.orderNo
    this.query()
    // console.log(this.$route.query.orderNo)
  },
  destroyed() {
    document.body.removeEventListener('keyup', e => {})
  },
  //   mounted(){
  //   this.$nextTick(() => {
  //   this.editorder()
  // })

  // },
  // 下拉框的选项
  async created() {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    // // 字典为师傅星级
    // this.time_type = [];
    // this.restaurantOperTypeMap = await getDictMap('time_type');
    // this.restaurantOperTypeMap.forEach((value, key) => {
    //   // console.log(value,key)
    //   this.time_type.push({code: key, label: value})
    //   // console.log(this.restaurantTypes)
    // })
    // 订单负责人
    this.masterPrincipal = []
    await getmasterPrincipal().then(res => {
      this.masterPrincipal = res
    })
    this.findByDeptId = []
    await getfindByDeptId().then(res => {
      this.findByDeptId = res
    })
    this.marketPrincipal = []
    await getmarketPrincipal().then(res => {
      this.marketPrincipal = res
    })
    // 企业名称
    this.selectCombox = []
    await getselectCombox().then(res => {
      if (res.code === 0) {
        this.selectCombox = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectSource = []
    // 查询信息来源下拉框
    await getselectSource().then(res => {
      if (res.code === 0) {
        this.selectSource = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectChannel = []
    await getselectChannel().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectChannel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    selectFindAll({
      dictTypes:
        'remove_type,sys_yes_no,order_substate,install_type,order_status,delivery_company,settle_role,settlement_status'
    }).then(res => {
      // 字典为结算状态
      this.remove_type = []
      this.restaurantOperTypeMap = res.remove_type
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.remove_type.push({ code: key, label: value })
        // console.log(this.restaurantTypes)
      })
      console.log(this.remove_type)

      // 字典为是否
      this.restaurantTypes = []
      this.restaurantOperTypeMap = res.sys_yes_no
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({ code: key, label: value })
        // console.log(this.restaurantTypes)
      })

      this.order_substate = []
      this.restaurantOperTypeMap = res.order_substate
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.order_substate.push({ code: key, label: value })
        // console.log(this.restaurantTypes)
      })
      // 字典为安装类型
      this.installTypes = []
      this.restaurantOperTypeMap = res.install_type
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.installTypes.push({ code: value.dictValue, label: value.dictLabel })
        // console.log(this.installTypes)
      })
      // 字典为订单状态
      this.order_status = []
      this.restaurantOperTypeMap = res.order_status
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.order_status.push({ code: value.dictValue, label: value.dictLabel })
        // console.log(this.restaurantTypes)
      })

      // 字典为快递公司
      this.delivery_company = []
      this.restaurantOperTypeMap = res.delivery_company

      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.delivery_company.push({ code: key, label: value })
        // console.log(this.restaurantTypes)
      })
      console.log(this.delivery_company, '快递公司')

      // 字典为结算角色
      this.settle_role = []
      this.restaurantOperTypeMap = res.settle_role
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.settle_role.push({ code: key, label: value })
        // console.log(this.restaurantTypes)
      })
      // 字典为结算状态
      this.settlement_status = []
      this.restaurantOperTypeMap = res.settlement_status
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.settlement_status.push({ code: key, label: value })
        // console.log(this.restaurantTypes)
      })
    })

    this.selectBrand = []
    await getSelectBrand().then(res => {
      if (res.code === 0) {
        this.selectBrand = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectModel = []
    await getSelectModel().then(res => {
      if (res.code === 0) {
        this.selectModel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  // 计算选中的数据条数
  computed: {},
  methods: {
    setClassName(record) {
      if (record.isTimeoutOrder == 1) {
        return 'clickRowStyle'
      }
    },

    moment,
    // 更多、隐藏
    getMore() {
      this.isShow = 1
    },
    // 失败文件处理
    handleSubmit2() {
      if (this.err == 0) {
        this.bisible = false
      } else {
        downloadErrorMaster(this.arrList).then(res => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          let fileName = '导入失败师傅文件'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
        this.bisible = false
      }
    },
    // // 上传
    handleChange(info) {
      // console.log(info)
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
        this.handleOk()
        // console.log(info.file.response.data)
        let file = info.file.response.data
        if (file.successNum == 0) {
          this.bisible = true
          this.success = file.success
          this.err = file.failNum
          this.arrList = file.failDtoList
          // this.err =file.error
          // this.arrList =file.errorList
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },

    // handleChange(info) {
    //   console.log(info,'res')
    //   if (info.file.status !== 'uploading') {
    //     // console.log(info.file, info.fileList);
    //   }
    //   if (info.file.status === 'done') {
    //     this.$message.success('上传成功')
    //     console.log(info.file.response.data)
    //     let file = info.file.response.data
    //     this.visible = true
    //     this.success =file.success
    //     this.err =file.error
    //     this.arrList =file.errorList
    //   } else if (info.file.status === 'error') {
    //     this.$message.error(`${info.file.name} 上传失败.`);
    //   }
    // },

    hiddenMore() {
      this.isShow = 0
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    exportEnted() {
      var str = process.env.VUE_APP_API_BASE_URL + '/order/enterpriseOrder/exportEnt?pageNum=1&pageSize=10'
      console.log(this.queryParam)
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      console.log(str)
      window.open(str)
      // // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      // // parent.location.href = getVUE_APP_GATEWAR_BASE_URL1()+"/api/apartment/callManage/exportCallManage?"+'attendanceTimestr='+this.queryParam.attendanceTimestr+'&callType='+this.queryParam.callType+'&checkInStatus='+this.queryParam.checkInStatus+'&name='+this.queryParam.name
      // exportEnt(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '_订单列表'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    reformistOk() {
      this.formreformist.validateFields((err, values) => {
        if (!err) {
          // console.log(values)
          getchangeOrderPrincipal(values).then(res => {
            if (res.code === 0) {
              this.reformistible = false
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    orderReformist(record) {
      this.reformistible = true
      this.$nextTick(() => {
        this.formreformist.setFieldsValue(pick(record, 'orderId'))
      })
      let orderPrincipal = record.orderPrincipal
      if (orderPrincipal) {
        setTimeout(
          () =>
            this.formreformist.setFieldsValue({
              oldorderPrincipal: orderPrincipal
            }),
          16
        )
      }
    },
    remarkInfo(record) {
      this.remarkInfoState = true
    },
    query() {
      this.$refs.table.refresh(true)
      this.selectedRowKeys = []
    },
    removeTypechange(value) {
      console.log(value)
      if (value == 0) {
        this.removerequiredbool = false
      } else {
        this.removerequiredbool = true
      }
    },
    empty() {
      this.queryParam = {}
      this.dtoListtab = {}
      this.dtoListtab2 = {}
      this.dtoListtab3 = {}
      this.checkboxlist = {}
      // this.dtoList=[]
    },
    // queryParam = {}
    addremark(record) {
      if (record) {
        this.$refs.changeremarksmodel.showChangeRemark(record.orderId)
      }
    },
    determinechangeclientAddress() {
      this.formchangeclientAddress.validateFields((err, values) => {
        values.clientAddress = values.address
        if (!err) {
          getupdateOrder({ orderId: values.orderId, orderClient: values }).then(res => {
            if (res.code === 0) {
              this.changeclientAddressible = false
              this.$message.success('操作成功')
              this.$refs.table.refresh()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    changeclientAddress(record) {
      this.changeclientAddressible = true
      console.log(record)
      this.$nextTick(() => {
        this.formchangeclientAddress.setFieldsValue(
          pick(record, 'orderId', 'areaId', 'provinceId', 'cityId', 'address')
        )
      })
      getselectCityName({ provinceCode: record.provinceId }).then(res => {
        if (res.code === 0) {
          /* console.log(res)*/
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      getselectAreaName({ cityCode: record.cityId }).then(res => {
        if (res.code === 0) {
          /* console.log(res)*/
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reassignmentorder(record) {
      console.log(record)
      getagainDispatchOrder({ orderId: record.orderId, procInstId: record.procInstId }).then(res => {
        if (res.code === 0) {
          this.$refs.table.refresh()
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    dispatchBatch() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.error('至少选择一条数据')
      } else {
        this.$refs.leaflets.showleaflets(this.selectedRowKeys)
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    onChangerangepicker(date, dateString) {
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },

    editorder(record) {
      console.log(record)
      this.$nextTick(() => {
        this.$refs.editordermodel22.showeditOrder(record.orderId, '', 1, record.orderSubStatusAll)
      })
    },
    distribute(record) {
      // console.log(record)
      getorderInfo({ orderId: record.orderId }).then(res => {
        if (res.code === 0) {
          this.$refs.leaflets.showleaflets(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    selectoptionChange(e) {
      // this.dtoList
    },
    onChangeTemporarily(e) {
      this.queryParam.isTemporarilySettle = e.target.checked ? '1' : '0'
    },
    onChangeUndoneOrder(e) {
      this.queryParam.notFinishOrder = e.target.checked ? '1' : '0'
    },
    onChangeMyOrder(e) {
      this.queryParam.isMyOrder = e.target.checked ? '1' : '0'
    },
    onChangeUrgentOrder(e) {
      this.queryParam.urgentOrder = e.target.checked ? '1' : '0'
    },
    onChangeMainOrder(e) {
      this.queryParam.weightOrder = e.target.checked ? '1' : '0'
    },
    onChangeFreezeOrder(e) {
      this.queryParam.isFreezeOrder = e.target.checked ? '1' : '0'
    },
    goNewlyaddedOrderList() {
      this.$refs.newlyaddedorderlist.showNewlyaddedOrderList()
      // this.$router.push({name:'NewlyaddedOrderList'})
    },
    async installChange(e) {
      this.List = []
      this.queryParam.orderType = ''
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 单选
    onChangeRadioGroup(e) {
      console.log(e.target.value)
    },
    // 多选
    onChangeCheckbox(checkedValues) {
      console.log(checkedValues)
      console.log(this.valuecheckbox)
    },
    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 型号
    changeModelName(e) {
      this.queryParam.modelId = e
    },
    // 品牌
    changeBrandName(e) {
      this.queryParam.brandId = e
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    // 移除
    delByIds(record) {
      this.form.resetFields()
      this.removeible = true
      this.orderId = record.orderId
    },
    // removerequiredbool
    // 移除确定时调用的方法
    async confirmOk() {
      await this.form.validateFields((err, values) => {
        values.removeText = values.removeText ? values.removeText : '""'
        if (!err) {
          getdeleteOrder({ orderId: this.orderId, removeText: values.removeText, removeType: values.removeType }).then(
            res => {
              console.log(res)
              if (res.code === 0) {
                this.removeible = false
                this.removeLoading = false
                this.handleOk()
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        }
      })
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
      this.orderid = []
    },
    handleremark(record) {
      this.$refs.modal.remark(record)
      console.log(record)
    },
    handleOk() {
      this.$refs.table.refresh()
    }
  },
  watch: {}
}
</script>

<style scoped>
/deep/ .clickRowStyle {
  background: #ffbcb7;
}

/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
</style>
